export const AreaGraphConfig = {
  title: {
    text: 'DAS ___',
  },
  chart: {
    type: 'arearange',
    zoomType: 'x',
  },
  xAxis: {
    type: 'category',
  },
  yAxis: {
    title: {
      text: null,
    },
  },
  tooltip: {
    crosshairs: true,
    shared: true,
    valueSuffix: 'm/s^2',
  },
  legend: {
    enable: false,
  },
  series: [],
};

export const seriesConfig = {
  name: 'Range',
  data: [],
  fillOpacity: 0.95,
  lineWidth: 0,
  zIndex: 0,
  turboThreshold: 0,
  linkedTo: ':previous',
};

export const LineChartConfig = {
  chart: {
    zoomType: 'x',
  },
  title: {
    text: 'Realtime Acceleration',
    x: -20, // center
  },
  xAxis: {
    type: 'category',
  },
  yAxis: {
    title: {
      text: null,
    },
    plotLines: [
      {
        value: 0,
        width: 1,
        color: '#808080',
      },
    ],
  },
  tooltip: {
    valueSuffix: 'm/s^2',
  },
  series: [
    {
      name: 'Ch0',
      data: [],
    },
    {
      name: 'Ch1',
      data: [],
    },
    {
      name: 'Ch2',
      data: [],
    },
  ],
};



// WEBPACK FOOTER //
// ./resources/assets/js/containers/SeismicWave/config.js